import { savePuzzleProgress } from '../../../utils/persistenceUtils';
import { PathwordData, PuzzleNames, STATS_DIALOG_DELAY } from '../../../utils/types';
import { getZeroMatrix } from '../Pathword/PathwordStore';
import { generateNumberedMatrixFromPositionPath, getLineOrientationsForPath, getHintPositions, getEnabledHintsForPathword5x5 } from '../Pathword/pathwordUtils';
import { Pathword5x5Store } from './Pathword5x5Store';

export const initPathword5x5 = (puzzleData: PathwordData, numDefaultHints: number = 4) => {
  Pathword5x5Store.update(s => {
    s.puzzleId = puzzleData.puzzleId;
    s.cluetext = puzzleData.cluetext;
    s.vowelMatrix = puzzleData.vowelMatrix;
    s.solutionPath = generateNumberedMatrixFromPositionPath(puzzleData.solutionPath);
    s.solutionLines = getLineOrientationsForPath(s.solutionPath);
    s.hintLetters = puzzleData.hintLetters;
    s.hintPositions = getHintPositions(puzzleData.solutionPath, puzzleData.hintLetters);
    s.enabledHints = getEnabledHintsForPathword5x5(numDefaultHints);
    s.initialEnabledHints = numDefaultHints;
  });
};

export const onReveal = () => {
  Pathword5x5Store.update(s => {
    clearInterval(s.timerUpdatingFn);
    s.highlights = getZeroMatrix(5);
    s.revealed = true;
    s.isPaused = false;

    savePuzzleProgress(PuzzleNames.Pathword5x5, {
      puzzleId: s.puzzleId,
      revealed: true,
      solved: false,
      time: s.time,
    });
  });
};

export const onSolve = () => {
  const { time, timerUpdatingFn, puzzleId } = Pathword5x5Store.getRawState();

  // This puzzle has a lengthy success animation, and we delay setting solved=true
  // until after it's done, in the setTimeout below.
  // Since the pause functionality doesn't stop the timer until the puzzle is marked solved,
  // we stop it here immediately as a courtesy, before the success animation finishes.
  clearInterval(timerUpdatingFn);
  
  setTimeout(() => {
    Pathword5x5Store.update(s => {
      s.statsDialogIsOpen = true;
      s.solved = true;
    });
  }, STATS_DIALOG_DELAY);
  
  savePuzzleProgress(PuzzleNames.Pathword5x5, {
    puzzleId,
    revealed: false,
    solved: true,
    time,
  });
};

export const savePathword5x5 = () => {
  const { solved, revealed, time, puzzleId } = Pathword5x5Store.getRawState();

  if (solved || revealed) return;

  // just updating progress on pause or navigate away
  savePuzzleProgress(PuzzleNames.Pathword5x5, {
    puzzleId,
    revealed,
    solved,
    time,
  });
};

// operates on the draft from the pullstate store
export const resetPathword5x5Data = (s: any) => {
  s.path = getZeroMatrix(5);
  s.lines = {};
  s.highlights = getZeroMatrix(5);
  s.pathLength = 0;
  s.pathHead = null;
  s.successAnimationGrid = getZeroMatrix(5);
};